export default __webpack_public_path__ + "static/media/YAS0770.34I-35489_-25127_0.db600af9.jpg";